// extracted by mini-css-extract-plugin
export var quillEditor = "_oq-1";
export var variable = "_oq-0";